// extracted by mini-css-extract-plugin
export default {"commentBox":"t_z9dx","withPadding":"oQFtk9"};